import React, { useEffect, useState } from "react";
import { useDashboardContext } from "../../../context/dashboardContext";
import { useNavigate, useParams } from "react-router-dom";
import { ArtistAdminResponseDTO } from "../../../openapi-generated-client";
import Loader from "../../../components/loader";
import { getApiUrl } from "../../../data/api/apiManager";
import UserVerifiedIcon from "../../../components/userVerifiedIcon";
import LinkIcon from "../../../assets/icons/linkIcon";
import { useSafeNavigate } from "../../../components/unloadBlocker";
import AccountIcon from "../../../assets/icons/accountIcon";
import InfoBoxes from "../../../components/infoBoxes";
import { formatDate } from "../../../utils/dateUtils";
import Button from "../../../components/button";

import "./dashboardAdminArtistPage.css";
import BookIcon from "../../../assets/icons/bookIcon";

export default function DashboardAdminArtistPage() {

    const navigate = useSafeNavigate(useNavigate());

    const {id} = useParams();

    const {appContext, sessionId} = useDashboardContext();
    const {artistController} = appContext;

    const [data, setData] = useState<ArtistAdminResponseDTO>();
    const [error, setError] = React.useState<string | undefined>(undefined);

    async function fetchData() {
        setData((await artistController.getArtistAdmin(Number(id), sessionId)).data);
    }

    useEffect(() => {
        fetchData();
    }, [id]);


    if(isNaN(Number(id))) {
        window.location.href="/error/2";
        return <></>;
    }

    if(data == undefined) return <Loader/>;

    return  <div className="page admin-account-page">
        <div className="artist-info">
            <img className="profile-picture" src={getApiUrl("assets/by-hash/" + data.artist.profilePicture)}/>
            <h1>{data.artist.name}
            <UserVerifiedIcon artist={data.artist}/>
            </h1>
            <p>{data.artist.shortBiography}</p>
            <div className="link-buttons">
                {data.accountId && data.accountId > 0 && <div className="open-profile" onClick={() => {
                    navigate("/dashboard/admin/accounts/" + data.accountId);
                }}>
                    <AccountIcon/>
                </div>}
                <div className="open-profile" onClick={() => {
                    window.open("/artists/" + data.artist.id, "_blank")
                }}>
                    <LinkIcon/>
                </div>
                <div className="open-profile" onClick={() => {
                    navigate("profile");
                }}>
                    <BookIcon/>
                </div>
            </div>
        </div>
        

        <InfoBoxes infos={[
            { title: ["Pieces", "Likes", "Downloads"], value: [data.piecesAmount, data.likesAmount, data.downloadsAmount] },
            { title: ["Joined", "Last Edited"], value: [formatDate(new Date(data.joined)), formatDate(new Date(data.lastUpdated))] }
        ]}/>
        <div className="txoria-text-field">
            <label>Pieces AVG Score</label>
            <a>{Math.round(data.avgPieceScore)}</a>
        </div>
        <p className="error">{error}</p>
        <div className="buttons">
            <Button onClick={async function() {
                await artistController.deleteArtist(Number(id), sessionId).then(() => {
                    navigate("/dashboard/admin/artists")
                }).catch((e) => {
                    setError(e.response.data.message || "An error occurred while verifying the account.");
                });
            }} className="primary">Delete</Button>
        </div>

    </div>
}